import { RouteRecordRaw } from "vue-router";
import { PermissionEnum } from "@altertec_gparn/lib";

export const certificationsDossierRoutes: RouteRecordRaw = {
  path: "dossier",
  name: "Certifications Dossiers",
  redirect: { name: "Certifications Dossier List" },
  meta: { permissions: [PermissionEnum.PROJECTS_DOSSIER] },
  component: () => import("@/layouts/EmptyLayout.vue"),
  children: [
    {
      path: "list",
      name: "Certifications Dossier List",
      component: () => import("@/views/auth/projects/dossiers/Dossiers.vue"),
    },
    {
      path: "new",
      name: "Certifications Create Dossier",
      component: () => import("@/views/auth/projects/dossiers/CreateDossier.vue"),
    },
    {
      path: "detail/:id",
      name: "Certifications Dossier Detail",
      redirect: { name: "Certifications Dossier Economic Summary" },
      component: () => import("@/views/auth/projects/dossiers/DossierDetail.vue"),
      props: true,
      children: [
        {
          path: "summary",
          name: "Certifications Dossier Economic Summary",
          component: () => import("@/modules/dossiers/tabs/EconomicSummaryTab.vue"),
          props: true,
        },
        {
          path: "projects",
          name: "Certifications Dossier's Projects",
          component: () => import("@/modules/dossiers/tabs/ProjectsTab.vue"),
          props: true,
        },
        {
          path: "certifications",
          name: "Certifications Dossier's Certifications",
          component: () => import("@/modules/dossiers/tabs/CertificationsTab.vue"),
          props: true,
        },
        {
          path: "valuations",
          name: "Certifications Dossier's Valuations",
          component: () => import("@/modules/dossiers/tabs/ValuationsTab.vue"),
          props: true,
        },
        {
          path: "worksheets",
          name: "Certifications Dossier's Worksheets",
          component: () => import("@/modules/dossiers/tabs/WorksheetsTab.vue"),
          props: true,
        },
        {
          path: "expenses",
          name: "Certifications Dossier's Expenses",
          component: () => import("@/modules/dossiers/tabs/ExpensesTab.vue"),
          props: true,
        },
        {
          path: "on-calls",
          name: "Certifications Dossier's On Calls",
          component: () => import("@/modules/dossiers/tabs/DossierOnCallsTab.vue"),
          props: true,
        },
      ],
    },
    {
      path: "edit/:id",
      name: "Certifications Edit Dossier",
      component: () => import("@/views/auth/projects/dossiers/EditDossier.vue"),
      props: true,
    },
  ],
};
